import { onAuthStateChanged } from "firebase/auth";
import type { User } from "firebase/auth";
import { useContext, useEffect, useState } from "react";

import AuthContext from "@/contexts/AuthContext";
import { auth } from "@/lib/firebase";
import { AuthState } from "@/types/auth";

export function useAuthMinimal() {
  const context = useContext(AuthContext);
  const hasProvider = context !== null;
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  /**
   * Listen for authentication state changes
   */
  useEffect(() => {
    if (hasProvider) return;
    const unsubscribe = onAuthStateChanged(
      auth,
      (firebaseUser: User | null) => {
        if (firebaseUser) {
          setUser(firebaseUser);
        } else {
          setUser(null);
        }

        setLoading(false);
      }
    );

    return unsubscribe;
  }, [hasProvider]);

  if (context) {
    const pending = [
      AuthState.GOOGLE_SIGNIN,
      AuthState.VERIFYING,
      AuthState.SENDING_TO_EXTENSION
    ].includes(context.state);
    return {
      user: context.state === AuthState.AUTHENTICATED ? context.user : null,
      loading: context.loading || pending,
    };
  }
  return { user, loading };
}
